// 3rd party
import * as React from 'react';

// Shared UI
// import { LocalizedText } from '@shared-ui/localization-context';

// UI Toolkit
import { UitkSpacing } from 'uitk-react-spacing';
import { UitkHeading, UitkParagraph } from 'uitk-react-text';

interface WidgetPreviewProps {
  children: React.ReactNode;
}

const WidgetPreview = React.memo(
  // tslint:disable-next-line:no-shadowed-variable
  function WidgetPreview(props: WidgetPreviewProps): JSX.Element {
    const { children } = props;

    return (
      <section>
        <UitkHeading tag="h2" size={4}>
          {/*<LocalizedText message="product.widget.preview.title" />*/}
          {'Preview'}
        </UitkHeading>

        <UitkParagraph size={1}>
          {/*<LocalizedText message="product.widget.preview.information" />*/}
          {'This is how the widget will display on your website.'}
        </UitkParagraph>

        {/* #widget-container */}
        <UitkSpacing margin={{ blockstart: 'four' }}>
          <div>
            {/* Add product-specific WidgetPreviewFrame component/s */}
            {children}
          </div>
        </UitkSpacing>
      </section>
    );
  },
);

export { WidgetPreview };
